/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CallModel } from '../models/CallModel';
import type { CommentInput } from '../models/CommentInput';
import type { CommentResponse } from '../models/CommentResponse';
import type { ConfirmVisitDateRequest } from '../models/ConfirmVisitDateRequest';
import type { CustomerData } from '../models/CustomerData';
import type { EnquiriesAttentionInput } from '../models/EnquiriesAttentionInput';
import type { EnquiriesAttentionResponse } from '../models/EnquiriesAttentionResponse';
import type { EnquiryCrmContractInfo } from '../models/EnquiryCrmContractInfo';
import type { EnquiryCrmData } from '../models/EnquiryCrmData';
import type { EnquiryCrmDto } from '../models/EnquiryCrmDto';
import type { EnquiryCrmRequest } from '../models/EnquiryCrmRequest';
import type { EnquiryCrmResultDto } from '../models/EnquiryCrmResultDto';
import type { EnquiryCrmSingleDto } from '../models/EnquiryCrmSingleDto';
import type { EnquiryCrmStatus } from '../models/EnquiryCrmStatus';
import type { EnquiryCrmTaskData } from '../models/EnquiryCrmTaskData';
import type { EnquiryCrmTaskHistoryResponse } from '../models/EnquiryCrmTaskHistoryResponse';
import type { EnquiryCrmTaskNoteInput } from '../models/EnquiryCrmTaskNoteInput';
import type { EnquiryCrmTaskStatus } from '../models/EnquiryCrmTaskStatus';
import type { EnquiryCrmTaskTypeFilter } from '../models/EnquiryCrmTaskTypeFilter';
import type { EnquiryLookUpInput } from '../models/EnquiryLookUpInput';
import type { EnquiryOrderResponse } from '../models/EnquiryOrderResponse';
import type { GetEnquiryRequirementResponse } from '../models/GetEnquiryRequirementResponse';
import type { InfoSourceDto } from '../models/InfoSourceDto';
import type { MakeEnquiryInput } from '../models/MakeEnquiryInput';
import type { NewOrUsedFilter } from '../models/NewOrUsedFilter';
import type { RequirementModel } from '../models/RequirementModel';
import type { RescheduleTaskRequest } from '../models/RescheduleTaskRequest';
import type { ResponsibleUserTimeData } from '../models/ResponsibleUserTimeData';
import type { SaveEnquiryRequirementRequest } from '../models/SaveEnquiryRequirementRequest';
import type { SaveTaskRequest } from '../models/SaveTaskRequest';
import type { SortTypeEnum } from '../models/SortTypeEnum';
import type { TrafficResponse } from '../models/TrafficResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EnquiryService {

  /**
   * @param searchCustomer 
   * @param searchEmail 
   * @param searchPhone 
   * @param searchEnquiryId 
   * @param ownerId 
   * @param fromDate 
   * @param toDate 
   * @param status
 *
 * 0 = All
 *
 * 1 = Active
 *
 * 2 = LostSale
 *
 * 3 = Quoted
 *
 * 4 = Order
 *
 * 5 = Invoice
 *
 * 6 = Delivery
 *
 * 7 = SendToLostSale
   * @param branchId 
   * @param newOrUsed
 *
 * 0 = New
 *
 * 1 = Used
 *
 * 2 = NewAndUsed
   * @param sourceIds 
   * @param modelIds 
   * @param hasTraffic 
   * @param hasAppointment 
   * @param hasTestDrive 
   * @param hasQuoted 
   * @param hasAppraisal 
   * @param sort 
   * @param order
 *
 * 0 = ASC
 *
 * 1 = DESC
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns EnquiryCrmResultDto Success
   * @throws ApiError
   */
  public static getEnquiryGetEnquiriesCrm(
    searchCustomer?: string,
    searchEmail?: string,
    searchPhone?: string,
    searchEnquiryId?: number,
    ownerId?: number,
    fromDate?: string,
    toDate?: string,
    status?: EnquiryCrmStatus,
    branchId?: number,
    newOrUsed?: NewOrUsedFilter,
    sourceIds?: Array<number>,
    modelsIds?: Array<number>,
    hasTraffic?: boolean,
    hasAppointment?: boolean,
    hasTestDrive?: boolean,
    hasQuoted?: boolean,
    hasAppraisal?: boolean,
    hasOpenAttentions?: boolean,
    sort?: string,
    order?: SortTypeEnum,
    skipPagination?: boolean,
    page?: number,
    maxCount?: number,
  ): CancelablePromise<EnquiryCrmResultDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetEnquiriesCrm',
      query: {
        'SearchCustomer': searchCustomer,
        'SearchEmail': searchEmail,
        'SearchPhone': searchPhone,
        'SearchEnquiryId': searchEnquiryId,
        'OwnerId': ownerId,
        'FromDate': fromDate,
        'ToDate': toDate,
        'Status': status,
        'BranchId': branchId,
        'NewOrUsed': newOrUsed,
        'SourceIds': sourceIds,
        'ModelsIds': modelsIds,
        'HasTraffic': hasTraffic,
        'HasAppointment': hasAppointment,
        'HasTestDrive': hasTestDrive,
        'HasQuoted': hasQuoted,
        'HasAppraisal': hasAppraisal,
        'HasOpenAttentions': hasOpenAttentions,
        'Sort': sort,
        'Order': order,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns EnquiryCrmSingleDto Success
   * @throws ApiError
   */
  public static getEnquiryGetFullEnquiryCrmById(
id?: number,
): CancelablePromise<EnquiryCrmSingleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetFullEnquiryCrmById',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns InfoSourceDto Success
   * @throws ApiError
   */
  public static getEnquiryGetInfoSources(): CancelablePromise<Array<InfoSourceDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetInfoSources',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns EnquiryCrmData Success
   * @throws ApiError
   */
  public static getEnquiryGetEnquiry(
id?: number,
): CancelablePromise<EnquiryCrmData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetEnquiry',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param enquiryCrmId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putSaveLookupEnquiry(
enquiryCrmId?: number,
requestBody?: EnquiryLookUpInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/SaveLookupEnquiry',
      query: {
        'enquiryCrmId': enquiryCrmId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param findDateFrom
   * @param enquiryCrmId
   * @param hasOrder
   * @param requestBody
   * @returns EnquiryCrmDto Success
   * @throws ApiError
   */
  public static postLookupEnquiryCrm(
    findDateFrom?: string,
    enquiryCrmId?: number,
    hasOrder: boolean = false,
    requestBody?: CustomerData,
  ): CancelablePromise<Array<EnquiryCrmDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/LookupEnquiryCrm',
      query: {
        'findDateFrom': findDateFrom,
        'enquiryCrmId': enquiryCrmId,
        'hasOrder': hasOrder,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns EnquiryCrmDto Success
   * @throws ApiError
   */
  public static postCreateEnquiryCrm(
requestBody?: EnquiryCrmRequest,
): CancelablePromise<EnquiryCrmDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateEnquiryCrm',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns EnquiryCrmDto Success
   * @throws ApiError
   */
  public static putUpdateEnquiryCrm(
requestBody?: EnquiryCrmRequest,
): CancelablePromise<EnquiryCrmDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/UpdateEnquiryCrm',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postEnquiry(
requestBody?: MakeEnquiryInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Enquiry',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postEnquirySaveTask(
requestBody?: SaveTaskRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Enquiry/SaveTask',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putEnquiryRescheduleTask(
requestBody?: RescheduleTaskRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Enquiry/RescheduleTask',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param search 
   * @param startDate 
   * @param endDate 
   * @param branchId 
   * @param enquiryCrmId 
   * @param groupedByEvent 
   * @param userIds 
   * @param taskType 
   * @param status 
   * @param isNew 
   * @returns EnquiryCrmTaskData Success
   * @throws ApiError
   */
  public static getEnquiryGetTasks(
search?: string,
startDate?: string,
endDate?: string,
branchId?: number,
enquiryCrmId?: number,
groupedByEvent?: boolean,
userIds?: Array<number>,
taskType?: Array<EnquiryCrmTaskTypeFilter>,
status?: Array<EnquiryCrmTaskStatus>,
isNew?: boolean,
): CancelablePromise<Array<EnquiryCrmTaskData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetTasks',
      query: {
        'Search': search,
        'StartDate': startDate,
        'EndDate': endDate,
        'BranchId': branchId,
        'EnquiryCrmId': enquiryCrmId,
        'GroupedByEvent': groupedByEvent,
        'UserIds': userIds,
        'TaskType': taskType,
        'Status': status,
        'IsNew': isNew,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param isTraffic 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteEnquiryTasks(
id: number,
isTraffic?: boolean,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Enquiry/tasks/{id}',
      path: {
        'id': id,
      },
      query: {
        'isTraffic': isTraffic,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param search 
   * @param startDate 
   * @param endDate 
   * @param branchId 
   * @param enquiryCrmId 
   * @param groupedByEvent 
   * @param userIds 
   * @param taskType 
   * @param status 
   * @param isNew 
   * @returns EnquiryCrmTaskData Success
   * @throws ApiError
   */
  public static getEnquiryGetHandoverTasks(
search?: string,
startDate?: string,
endDate?: string,
branchId?: number,
enquiryCrmId?: number,
groupedByEvent?: boolean,
userIds?: Array<number>,
taskType?: Array<EnquiryCrmTaskTypeFilter>,
status?: Array<EnquiryCrmTaskStatus>,
isNew?: boolean,
): CancelablePromise<Array<EnquiryCrmTaskData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetHandoverTasks',
      query: {
        'Search': search,
        'StartDate': startDate,
        'EndDate': endDate,
        'BranchId': branchId,
        'EnquiryCrmId': enquiryCrmId,
        'GroupedByEvent': groupedByEvent,
        'UserIds': userIds,
        'TaskType': taskType,
        'Status': status,
        'IsNew': isNew,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param eventDate 
   * @param userId 
   * @param enquiryId 
   * @returns ResponsibleUserTimeData Success
   * @throws ApiError
   */
  public static getEnquiryGetResponsibleUserTimesByDate(
eventDate?: string,
userId?: number,
enquiriesCrmId?: number,
): CancelablePromise<Array<ResponsibleUserTimeData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetResponsibleUserTimesByDate',
      query: {
        'EventDate': eventDate,
        'UserId': userId,
        'EnquiriesCrmId': enquiriesCrmId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns EnquiryCrmTaskData Success
   * @throws ApiError
   */
  public static getEnquiryGetTaskById(
id?: number,
): CancelablePromise<EnquiryCrmTaskData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetTaskById',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static putEnquiryCancelledEvent(
id?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Enquiry/CancelledEvent',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @returns RequirementModel Success
   * @throws ApiError
   */
  public static getGetRequirementModels(): CancelablePromise<Array<RequirementModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetRequirementModels',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param carRegNo 
   * @returns RequirementModel Success
   * @throws ApiError
   */
  public static getGetRequirementModel(
carRegNo?: string,
): CancelablePromise<RequirementModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetRequirementModel',
      query: {
        'CarRegNo': carRegNo,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param enquiryCrmId 
   * @returns GetEnquiryRequirementResponse Success
   * @throws ApiError
   */
  public static getGetRequirement(
enquiryCrmId: number,
): CancelablePromise<GetEnquiryRequirementResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetRequirement',
      query: {
        'enquiryCRMId': enquiryCrmId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSaveRequirement(
requestBody?: SaveEnquiryRequirementRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveRequirement',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putEnquiryConfirmVisitDate(
requestBody?: ConfirmVisitDateRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Enquiry/ConfirmVisitDate',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param taskId 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns EnquiryCrmTaskHistoryResponse Success
   * @throws ApiError
   */
  public static getEnquiryTaskHistories(
taskId?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<EnquiryCrmTaskHistoryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/TaskHistories',
      query: {
        'TaskId': taskId,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postEnquiryAddTaskNote(
requestBody?: EnquiryCrmTaskNoteInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Enquiry/AddTaskNote',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns CommentResponse Success
   * @throws ApiError
   */
  public static getEnquiryGetEnquiryCrmNotes(
id: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<CommentResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetEnquiryCrmNotes',
      query: {
        'Id': id,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postEnquiryAddEnquiryCrmNote(
requestBody?: CommentInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Enquiry/AddEnquiryCrmNote',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param enquiryCrmId 
   * @param skipPagination 
   * @param page 
   * @param maxCount 
   * @returns EnquiriesAttentionResponse Success
   * @throws ApiError
   */
  public static getEnquiryGetEnquiriesAttention(
enquiryCrmId?: number,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<EnquiriesAttentionResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetEnquiriesAttention',
      query: {
        'EnquiryCrmId': enquiryCrmId,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postEnquiryAddEnquiriesAttention(
requestBody?: EnquiriesAttentionInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Enquiry/AddEnquiriesAttention',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postEnquiryClosedEnquiriesAttention(
id?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Enquiry/ClosedEnquiriesAttention',
      query: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param enquiryCrmId 
   * @param enquiryCrmTaskId 
   * @returns TrafficResponse Success
   * @throws ApiError
   */
  public static getEnquiryTraffic(
enquiryCrmId?: number,
enquiryCrmTaskId?: number,
): CancelablePromise<Array<TrafficResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/Traffic',
      query: {
        'EnquiryCrmId': enquiryCrmId,
        'EnquiryCrmTaskId': enquiryCrmTaskId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns CallModel Success
   * @throws ApiError
   */
  public static getEnquiryGetCalls(
id: number,
): CancelablePromise<Array<CallModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/GetCalls/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param ids 
   * @returns EnquiryCrmContractInfo Success
   * @throws ApiError
   */
  public static getEnquiryLastContracts(
ids?: Array<number>,
): CancelablePromise<Array<EnquiryCrmContractInfo>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/LastContracts',
      query: {
        'ids': ids,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param enquiryId 
   * @param enquiryCrmId 
   * @param fromDate 
   * @param toDate 
   * @returns EnquiryOrderResponse Success
   * @throws ApiError
   */
  public static getEnquiryOrders(
enquiryId?: number,
enquiryCrmId?: number,
fromDate?: string,
toDate?: string,
): CancelablePromise<Array<EnquiryOrderResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Enquiry/orders',
      query: {
        'EnquiryId': enquiryId,
        'EnquiryCrmId': enquiryCrmId,
        'FromDate': fromDate,
        'ToDate': toDate,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
